export {default as values} from 'lodash-es/values';

export function arrayToMap(arr, key = 'value') {
  return arr.reduce((obj, item) => {
    obj[item[key]] = item;

    return obj;
  }, {});
}

export function arrayReverseMap(arr) {
  return arr.reduce((obj, item, index) => {
    obj[item] = index;

    return obj;
  }, {});
}
